var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title1"},[_vm._t("default"),_c('div',{staticClass:"title1-line"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }